import { useClock } from '@/state/store';
import { TextButton } from '@/components/ui/primitives';
import { ARTEMIS_REPLAY, ARTEMIS_FLYBY, ARTEMIS_TRAJECTORY_START, ARTEMIS_TRAJECTORY_END } from '../replay';

export function MissionReplayBar() {
  // Select whole mission seconds instead of subsecond clock state.
  const second = useClock((s) => Math.floor(s.simTime / 1000));
  const time = second * 1000;
  const playing = useClock((s) => s.playing);
  const seek = (ms: number) => {
    useClock.getState().setPlaying(false);
    useClock.getState().setSimTime(ms);
  };
  const gap = time < ARTEMIS_TRAJECTORY_START || time > ARTEMIS_TRAJECTORY_END;
  return (
    <div
      className="pointer-events-auto w-[380px] max-w-full rounded-panel border border-hairline bg-raised/95 p-3 text-xs shadow-elev-1"
      data-testid="mission-replay"
    >
      <div className="flex items-center justify-between gap-2">
        <strong>Artemis II · historical replay</strong>
        <span className="text-ink-3">1–11 Apr 2026 UTC</span>
      </div>
      <input
        className="my-2 w-full accent-accent"
        type="range"
        aria-label="Mission replay position"
        min={ARTEMIS_REPLAY.startMs}
        max={ARTEMIS_REPLAY.endMs}
        step={1000}
        value={Math.max(ARTEMIS_REPLAY.startMs, time)}
        onChange={(e) => seek(Number(e.target.value))}
      />
      <div className="flex flex-wrap gap-1">
        <TextButton
          onClick={() => {
            const c = useClock.getState();
            if (c.simTime >= ARTEMIS_REPLAY.endMs) c.setSimTime(ARTEMIS_REPLAY.startMs);
            c.setPlaying(!playing);
          }}
        >
          {playing ? 'Pause mission' : 'Play mission'}
        </TextButton>
        <TextButton onClick={() => seek(ARTEMIS_REPLAY.startMs)}>Launch</TextButton>
        <TextButton onClick={() => seek(ARTEMIS_TRAJECTORY_START)}>Trajectory start</TextButton>
        <TextButton onClick={() => seek(ARTEMIS_FLYBY)}>Lunar flyby</TextButton>
        <TextButton onClick={() => seek(ARTEMIS_REPLAY.endMs)}>Splashdown</TextButton>
      </div>
      <p className="mt-2 text-[10px] leading-relaxed text-ink-3">
        {gap
          ? 'No published position for this ascent / final-entry interval. Select Trajectory start or Lunar flyby to follow Orion.'
          : 'JPL post-flight trajectory · 5-minute samples, interpolated. Playback stops at splashdown.'}
      </p>
    </div>
  );
}
